module.exports = __webpack_public_path__ + "static/media/logo_enterprise.bf111c52.jpg";